import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Dialog } from '../redesign/Dialog';
import pinStorage from '../../utils/pinStorage';
import { PinInput } from './PinInput';
import { Button } from '../redesign/Button';
import { USER_PIN_LENGTH } from '../../config/constants';
import { browserHistory } from 'react-router';
import { Text } from '../redesign/Text';
var submitButtonText = {
    manifest: 'Weiter zum Schiffsmanifest',
    payment: 'Weiter zu den Zahlungsmitteln',
    health: 'Weiter zum Gesundheitsfragebogen',
    checkin: 'Weiter zum Check-In',
    fallback: 'Weiter',
};
var PIN_LENGTH = USER_PIN_LENGTH;
export var PinDialog = function (_a) {
    var url = _a.url, onClose = _a.onClose, onSubmit = _a.onSubmit, partyMember = _a.partyMember, error = _a.error, _b = _a.btnText, btnText = _b === void 0 ? 'fallback' : _b;
    var _c = useState(''), pin = _c[0], setPin = _c[1];
    var _d = useState(false), hasOverflow = _d[0], setHasOverflow = _d[1];
    var scrollRef = useRef(null);
    var errorRef = useRef(null);
    // Check if scroll area has overflow
    var checkOverflow = useCallback(function () {
        var el = scrollRef.current;
        if (el) {
            setHasOverflow(el.scrollHeight > el.clientHeight);
        }
    }, []);
    useEffect(function () {
        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return function () { return window.removeEventListener('resize', checkOverflow); };
    }, [checkOverflow]);
    // Lock body scroll while dialog is open
    useEffect(function () {
        var originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = 'hidden';
        return function () {
            document.body.style.overflow = originalStyle;
        };
    }, []);
    // Scroll to error when it appears
    useEffect(function () {
        if (error && errorRef.current) {
            errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [error]);
    var handleClose = function () {
        if (partyMember) {
            pinStorage.removeUrl(partyMember.mpi);
        }
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var handleSubmit = function () {
        if (onSubmit) {
            onSubmit(pin);
            return;
        }
        if (partyMember) {
            pinStorage.setPin(partyMember.mpi, pin);
            browserHistory.replace(url);
            return;
        }
        browserHistory.replace('/404');
    };
    return (React.createElement(Dialog, { title: "Information", onClose: handleClose, isOpen: true },
        React.createElement("div", { className: "shrink-0 pt-2" },
            React.createElement(Text, { type: "h2", className: "text-md leading-[28.8px] md:leading-[1.2]" },
                "Bitte geben Sie die Sicherheits-PIN f\u00FCr ", partyMember === null || partyMember === void 0 ? void 0 :
                partyMember.firstName,
                ' ', partyMember === null || partyMember === void 0 ? void 0 :
                partyMember.lastName,
                " ein")),
        React.createElement("div", { ref: scrollRef, className: "flex-1 min-h-0 overflow-y-auto overscroll-contain mt-3 relative", onScroll: checkOverflow },
            React.createElement("div", { className: "flex flex-col gap-3 pb-6" },
                React.createElement(Text, { type: "sm", className: "md:text-md md:leading-[28.8px]" }, "Dieser Bereich ist aus Datenschutz\u00ADgr\u00FCnden gesch\u00FCtzt. Ihre PIN sind die letzten 4 Zeichen Ihres Ausweis\u00ADdokuments laut Manifest."),
                error && (React.createElement("div", { ref: errorRef },
                    React.createElement(Text, { type: "sm", className: "md:text-md md:leading-[28.8px] text-red-500" }, "Leider stimmt Ihre Eingabe nicht mit Ihrer Sicherheits-PIN \u00FCberein. Bitte \u00FCberpr\u00FCfen Sie Ihre Eingabe. Sollten Sie Probleme mit der Eingabe der Sicherheits-PIN haben, wenden Sie sich bitte an unser Serviceteam.")))),
            hasOverflow && (React.createElement("div", { className: "sticky bottom-0 left-0 right-0 h-6 md:h-10 pointer-events-none", style: {
                    backgroundImage: 'linear-gradient(to bottom, rgba(241,242,246,0.12) 0%, rgba(241,242,246,0.9) 75%, rgba(241,242,246,1) 100%)',
                    backfaceVisibility: 'hidden',
                    transform: 'translateZ(0)',
                    isolation: 'isolate'
                } }))),
        React.createElement("div", { className: "shrink-0 md:pt-4 flex flex-col items-center" },
            React.createElement(PinInput, { className: "my-2 md:my-4", pin: pin, onChange: function (e) {
                    setPin(e);
                }, onEnter: handleSubmit, length: PIN_LENGTH, wrongPin: !!error }),
            React.createElement("div", { className: "flex justify-center" },
                React.createElement(Button, { variant: "primary", size: "smToMd", onClick: handleSubmit, disabled: pin.length !== PIN_LENGTH }, submitButtonText[btnText])))));
};
